import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import * as _ from "lodash";

@Component({
  selector: "student-sort-filters-display",
  templateUrl: "./student-sort-filters-display.component.html",
  styleUrls: ["./student-sort-filters-display.component.scss"],
})
export class StudentSortFiltersDisplayComponent implements OnInit {
  @Input() studentSortFilters;
  @Input() columns;
  @Input() isGroupCriteria: boolean;
  @Input() showDeleteBtn: boolean;
  @Output() clickedDelete = new EventEmitter();

  metricRemovedFromDashboardText = "metric no longer on dashboard";
  currentCol;

  constructor() {}

  ngOnInit() {}

  getColName(id) {
    this.currentCol = _.find(this.columns, ["id", Number(id)]);
    if (this.currentCol) {
      return this.currentCol["title"];
    } else {
      return this.metricRemovedFromDashboardText;
    }
  }
}
